import React from "react";
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import CoreMessages from "@core/scripts/components/messages";
import createLayerNode from "@core/scripts/helper/create-layer-node";
import {createRoot} from 'react-dom/client';

export default function openLayer(LayerComponent, props) {
    if (!LayerComponent.layerId || !LayerComponent.root) {
        LayerComponent.layerId = 'o' + Math.random().toString().substr(2);
        LayerComponent.root = createRoot(createLayerNode(LayerComponent.layerId));
    }
    const layer = <LayerComponent layerId={LayerComponent.layerId} {...props} />;
    LayerComponent.root.render(layer);

    const layerId = LayerComponent.layerId;
    MessageBroker.publish(CoreMessages.LAYER.OPEN, {...props, layerId});
}
